import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';

export default function Card({ className, ...htmlProps }) {
    return (
        <div
            className={cn('bg-white rounded-xl border border-gray-200 p-6 sm:p-10 shadow-sm', className)}
            {...htmlProps}
        />
    );
}

Card.propTypes = {
    className: PropTypes.string,
};
